// extracted by mini-css-extract-plugin
module.exports = {"TDA_RIGHT_BOX":"TDA_RIGHT_BOX--3Jw6n"};